module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-9.fc97ddff.png";